export default __webpack_public_path__ + "static/media/joystick.00ac92e0.png";